import React from 'react';
import {
  FireOutlined,
  StarOutlined,
} from '@ant-design/icons';
import { ReactSVG } from 'react-svg';
import key_svg from '../../../../assets/images/key.svg';
import bispot_svg from '../../../../assets/images/bispot.svg';
import { SectionKeys, SectionDisplayKeys } from '../../../constant/index';

/**
 * 作業区分アイコンのプロパティ
 */
export interface SectionIconProps {
  /** 作業区分コード */
  sectionCode: SectionKeys | SectionDisplayKeys;
  /** サイズ */
  size?: number;
}

/**
 * 作業区分アイコンのコンポーネント
 * @param param0 作業区分アイコンのプロパティ
 * @returns 
 */
export const SectionIcon : React.FC<SectionIconProps> = ({ sectionCode, size }) => {
  // デフォルトのサイズ指定
  const s = size ?? 25;

  switch (sectionCode) {
    case SectionKeys.key:
      return <ReactSVG
        data-testid={`section-icon-${SectionKeys.key}`}
        src={key_svg}
        beforeInjection={(svg) => {
          svg.setAttribute('style', `width:${s}px; height: ${s}px;`);
        }}
      />;
    case SectionKeys.fire:
      return <FireOutlined 
        data-testid={`section-icon-${SectionKeys.fire}`}
        style={{ fontSize: `${s}px` }} />;
    case SectionKeys.ext:
      return <StarOutlined 
        data-testid={`section-icon-${SectionKeys.ext}`}
        style={{ fontSize: `${s}px` }} />;
    default:
      return <ReactSVG
        data-testid={`section-icon-${SectionKeys.bispot}`}
        src={bispot_svg}
        beforeInjection={(svg) => {
          svg.setAttribute('style', `width:${s}px; height: ${s}px;`);
        }}
      />;
  }
};
